export default function checkPGN(pgn) {
  return pgn.match(/^[0-9a-z]{3}-\d{2}(-|c)\d{5}(\d{2})?$/i);
}
